import { useTheme } from '../../hooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var AddCard = () => {
  var {
    colors
  } = useTheme();
  return /*#__PURE__*/_jsxs("svg", {
    height: "100%",
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M18 112C16.8954 112 16 111.105 16 110L16 35.8286C16 34.724 16.8954 33.8286 18 33.8286L126 33.8286C127.105 33.8286 128 34.724 128 35.8286L128 110C128 111.105 127.105 112 126 112L18 112Z",
      fill: colors.illustration.light
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18 113C15.7909 113 14 111.213 14 109.008L14 34.9917C14 32.7871 15.7909 31 18 31L126 31C128.209 31 130 32.7871 130 34.9917L130 109.008C130 111.213 128.209 113 126 113L18 113ZM18 34.9917L18 109.008L126 109.008L126 34.9917L18 34.9917Z",
      fill: colors.illustration.stroke
    }), /*#__PURE__*/_jsx("path", {
      d: "M130 53H14V72H130V53Z",
      fill: colors.illustration.stroke
    }), /*#__PURE__*/_jsx("path", {
      d: "M114 50C125.046 50 134 41.0457 134 30C134 18.9543 125.046 10 114 10C102.954 10 94 18.9543 94 30C94 41.0457 102.954 50 114 50Z",
      fill: colors.illustration.bg
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M114 46C122.837 46 130 38.8366 130 30C130 21.1634 122.837 14 114 14C105.163 14 98 21.1634 98 30C98 38.8366 105.163 46 114 46ZM134 30C134 41.0457 125.046 50 114 50C102.954 50 94 41.0457 94 30C94 18.9543 102.954 10 114 10C125.046 10 134 18.9543 134 30Z",
      fill: colors.illustration.stroke
    }), /*#__PURE__*/_jsx("path", {
      d: "M116 32H123V28H116V21L112 21V28H105L105 32H112V39H116V32Z",
      fill: colors.illustration.stroke
    })]
  });
};
//# sourceMappingURL=AddCard.js.map